import { useState, useEffect } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import Spinner from '../../components/common/Spinner'
import Button from '../../components/common/Button'
import ErrorAlert from '../../components/common/ErrorAlert'
import Modal from '../../components/modals/Modal'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import Notification from '../../components/common/Notification'


const DatosUsuario = () => {
  const [cargando, setCargando] = useState(true)
  const [usuario, setUsuario] = useState(null)
  const [idUsuario, setIdUsuario] = useState(JSON.parse(localStorage.getItem('user')).id)
  const [nombre, setNombre] = useState(null)
  const [apellidos, setApellidos] = useState(null)
  const [email, setEmail] = useState(null)
  const [mostrarModal, setMostrarModal] = useState(false)
  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  useEffect(() => {
    obtenerDatosUsuario()
  }, [])

  const obtenerDatosUsuario = async () => {
    try {
      const respuesta = await consumirApi('GET', `users/${idUsuario}/usuario`)
      if (respuesta.success) {
        setCargando(false)
        setUsuario(respuesta.data)
      } else {
        console.error(respuesta.error)
        setUsuario(null)
      }
    } catch (error) {
      console.error('Error al obtener los datos:', error)
      setUsuario(null)
    }

  }

  const abrirMostrarModal = ({ nombre, apellidos, email }) => {
    setNombre(nombre)
    setApellidos(apellidos)
    setEmail(email)
    setMostrarModal(true)
  }

  const enviarEdicionUsuario = async (e) => {
    e.preventDefault()
    try {
      const data = { nombres_usuario: nombre, apellidos_usuario: apellidos, email }
      const respuesta = await consumirApi('PATCH', `users/${idUsuario}/usuario`, data)
      if (respuesta.success) {
        setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Datos actualizados correctamente" })
        obtenerDatosUsuario()
        setMostrarModal(false)
      } else {
        setError(respuesta.error)
    }
    } catch (error) {
      console.error('Error al obtener los datos:', error)
      setUsuario(null)
    }
  }

  return (
    <>
      <div className="flex gap-3 w-full bg-gray-100">
        {notificacion.estado && (
          <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
        )}
        {cargando ? (
          <Spinner />
        ) : usuario ? (
          <div className="bg-white shadow-lg rounded-lg p-6 max-w-lg">
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-600">DNI: </span>
                <span className="text-gray-800">{usuario.dni_usuario}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-600">Nombres: </span>
                <span className="text-gray-800">{usuario.nombres_usuario}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-600">Apellidos: </span>
                <span className="text-gray-800">{usuario.apellidos_usuario}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-600">Email: </span>
                <span className="text-gray-800">{usuario.email}</span>
              </div>
            </div>
            <div className='flex justify-end'>
              <Button className="ml-5 mt-2" type="update" texto='Actualizar datos' onClick={() => abrirMostrarModal({
                id: usuario.id, nombre: usuario.nombres_usuario, apellidos: usuario.apellidos_usuario, email: usuario.email
              })} />

            </div>
          </div>
        ) : (
          <p className="text-red-500">No se pudieron cargar los datos del usuario.</p>
        )}
      </div>
      {/* Modal Registrar nuevo acción*/}
      <Modal isOpen={mostrarModal} title="Actualizar datos de usuario" onClose={() => setMostrarModal(false)} >
        <Form onSubmit={enviarEdicionUsuario}  type="update">
          <Input name="nombre" value={nombre} label="nombre" onChange={setNombre} />
          <Input name="apellidos" value={apellidos} label="apellidos" onChange={setApellidos} />
          <Input name="email" value={email} label="email" onChange={setEmail} />
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>
    </>
  )
}

export default DatosUsuario
